import { Action } from '@ngrx/store';
import { IBonusPointsModel } from '../../models/loyalty/IBonusPoints.model';

// @loyaltyDocs: Getting bonus points status from Amadeus+Me
// (triggers Java API)
export const GET_BONUS_POINTS = '[BonusPoints] Get Bonus Points';
export const GET_BONUS_POINTS_SUCCESS = '[BonusPoints] Get Bonus Points Success';
export const GET_BONUS_POINTS_ERROR = '[BonusPoints] Get Bonus Points Error';

// Actions for Getting Bonus points
export class GetBonusPoints implements Action {
  readonly type = GET_BONUS_POINTS;
  constructor() {}
}

export class GetBonusPointsSuccess implements Action {
  readonly type = GET_BONUS_POINTS_SUCCESS;
  constructor(public payload: IBonusPointsModel) {}
}

export class GetBonusPointsError implements Action {
  readonly type = GET_BONUS_POINTS_ERROR;
  constructor(public payload: string) {}
}

export type BonusPointsActions = GetBonusPoints | GetBonusPointsSuccess | GetBonusPointsError;
